import { Col, Text, Row, CMSLayout, Grid, Input, Button, useUIState, TouchField, showPopupMessage } from 'components';
import React, { useState, useEffect } from 'react';
import { IScreen } from 'type';
import Store from 'store';
import { useNavFunc } from 'navigation';
import { useDynamicResponsiveValue } from 'quickly-react';
import { SVG, ASSETS } from 'assets';
import { SCREEN, COLOR } from 'const';
import { ActivityIndicator, Image } from 'react-native';
import { Fontisto } from '@expo/vector-icons';

const ResellerRegister: IScreen = () => {
  const { navigate, reset, route } = useNavFunc();
  const UserStore = Store.useUserStore();
  const rV = useDynamicResponsiveValue();
  const { redirect }: any = route.params || {};

  const [email, setEmail] = useState('');
  const [agreedTOS, setAgreedTOS] = useState(true);
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [fullName, setFullName] = useState('');
  const [accountName, setAccountName] = useState('');
  const [addressLine1, setAddressLine1] = useState('');
  const [addressLine2, setAddressLine2] = useState('');
  const [town, setTown] = useState('');
  const [country, setCountry] = useState('');
  const [postCode, setPostCode] = useState('');

  const [{ loading }, setUI] = useUIState();

  const isMobile = rV({ xs: true, md: false });

  useEffect(() => {
    if (!!redirect) return;
    if (window.innerWidth <= 480) {
      reset(SCREEN.RegisterMobile);
    }
  }, [redirect]);

  const submit = async () => {
    if (!agreedTOS) {
      // alert('Please tick the checkbox to agree to our terms and conditions');
      showPopupMessage({
        title: '',
        content: 'Please tick the checkbox to agree to our terms and conditions',
        buttonOkText: 'OK',
        // 
        typeHighlight: 'warning',
        contentHighlight: 'Terms and conditions'

      });
      return;
    }
    if (!fullName|| !password || !confirmPassword) {
      // alert('Please fill in at least the following info: Full Name, Email, Password & Confirm password');
      showPopupMessage({
        title: '',
        content: 'Please fill in at least the following info: Full Name, Email, Password & Confirm password',
        buttonOkText: 'OK',
        // 
        typeHighlight: 'warning',
        contentHighlight: 'Forms validation'

      });
      return;
    }
    if (password !== confirmPassword) {
      // alert('Passwords not match');
      showPopupMessage({
        title: '',
        content: 'Passwords not match',
        buttonOkText: 'OK',
        // 
        typeHighlight: 'danger',
        contentHighlight: 'Forms validation'

      });
      return;
    }
    setUI({ loading: true });
    // split full name into first name and last name
    const names = fullName.split(' ');
    const firstName = names[0];
    const lastName = names.slice(1).join(' ');
    try {
      const res = await Store.Api.User.register({
        firstName,
        lastName,
        email,
        password,
        role: 'reseller',
      });
      if (res.data.error) {
        setUI({ loading: false });
        // return alert(String(res.data.error));
        return showPopupMessage({
          title: '',
          content: String(res.data.error),
          buttonOkText: 'OK',
          // 
          typeHighlight: 'danger',
          contentHighlight: 'Error'
  
        });
      }
      showPopupMessage({
        title: '',
        content: 'Register successfully.',
        buttonOkText: 'OK',
        // 
        typeHighlight: 'success',
        contentHighlight: 'Success'

      });
      // alert('Register successfully.');
      const token = res.data.data?.token;
      Store.Client.setToken(token);
      UserStore.set({
        token,
        user: res.data.data?.publicInfo,
      });
      if (redirect && redirect !== 'undefined') {
        reset(redirect);
      } else {
        reset(SCREEN.Home);
      }
      // reset(SCREEN.Login, { redirect: redirect === 'undefined' ? '' : redirect  });
      // alert('Register successfully. Please login now');
      // reset(SCREEN.Login, { redirect: redirect === 'undefined' ? '' : redirect  });
    } catch(err) {
      setUI({ loading: false, errorMes: '' });
      // alert(String(err));
      showPopupMessage({
        title: '',
        content: String(err),
        buttonOkText: 'OK',
        // 
        typeHighlight: 'danger',
        contentHighlight: 'Error'

      });
    }
    
  };

  return (
    <Col flex1 middle={!isMobile} p2>
      <Col width={isMobile ? '100%' : '50%'} borderRadius={20} bgMain overflow={'hidden'}>
        <Col
          style={{
            backgroundColor: COLOR.MAIN,
            height: 100,
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {/* <SVG.BottleGoose
            fill='white'
            width={'26.25%'}
          /> */}
          <Image source={ASSETS.LOGO} style={{ width: '65%', height: '100%', marginVertical: 5 }} resizeMode='contain' />
        </Col>
        <Col bgWhite p2>
          <Text bold fontSize={20}>Register here</Text>
          <Grid xs='100%' md='100%' lg='50%' marginHorizontal={-5}>
            <Col m0 mt1>
              <Text caption mb0>Full name</Text>
              <Input
                value={fullName}
                onChange={setFullName}
                placeholder={"Full Name"}
              />
            </Col>
            
            <Col m0 mt1>
              <Text caption mb0>Email</Text>
              <Input
                value={email}
                onChange={setEmail}
                placeholder={"Email"}
              />
            </Col>
            <Col m0 mt1>
              <Text caption mb0>Password</Text>
              <Input
                value={password}
                onChange={setPassword}
                placeholder={"Password"}
                password
              />
            </Col>
            <Col m0 mt1>
              <Text caption mb0>Confirm Password</Text>
              <Input
                value={confirmPassword}
                onChange={setConfirmPassword}
                placeholder={"Confirm Password"}
                password
              />
            </Col>
          </Grid>
          <Row m0 mt1>
              {/* Checkbox agreed to terms */}
              <TouchField
                onPress={() => {
                  // setAgree(!agree);
                  setAgreedTOS(!agreedTOS);
                }}
                cirle middle
              >
                <Fontisto name={agreedTOS ? "checkbox-active" : "checkbox-passive"} size={16} color="black" />
              </TouchField>
              <Text ml1 onPress={() => {
                  // setAgree(!agree);
                  setAgreedTOS(!agreedTOS);
                }}>By ticking, you are confirming that you have read, understood and agree to <a href={"https://www.bottledgoose.co.uk/pages/policies"} target='_blank' onClick={e => e.stopPropagation()}>our terms and conditions</a></Text>
          </Row>
          <Button
            isLoading={loading}
            onPress={submit}
            mt1
            text='Register'
            solid
            width={isMobile ? '100%' : '50%'}
            alignSelf='center'
            height={45}
          />

          <TouchField mt1 alignSelf={'center'} p0
            onPress={() => {
              reset(SCREEN.Login, { redirect: redirect === 'undefined' ? '' : redirect })
            }}
          >
            <Text textDecorationLine={'underline'}>Already registed? Login here</Text>
          </TouchField>
        </Col>
      </Col>
    </Col>
  )
};

ResellerRegister.routeInfo = {
  title: 'Reseller register - IT Luggage - Print Manager',
  path: '/reseller-register',
};

export default ResellerRegister;
